/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import * as Player from 'store/ducks/player';
import store from 'store/store';

export enum EShakaLogString {
  NONE = 'none',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  DEBUG = 'debug',
  V1 = 'v1',
  V2 = 'v2',
}

export enum EShakaLogLevel {
  NONE = 0,
  ERROR = 1,
  WARNING = 2,
  INFO = 3,
  DEBUG = 4,
  V1 = 5,
  V2 = 6,
}

function parseLogLevel(level: string) {
  let value: number | undefined;

  switch (level) {
    case EShakaLogString.NONE:
      value = EShakaLogLevel.NONE;
      break;
    case EShakaLogString.ERROR:
      value = EShakaLogLevel.ERROR;
      break;
    case EShakaLogString.WARNING:
      value = EShakaLogLevel.WARNING;
      break;
    case EShakaLogString.INFO:
      value = EShakaLogLevel.INFO;
      break;
    case EShakaLogString.DEBUG:
      value = EShakaLogLevel.DEBUG;
      break;
    case EShakaLogString.V1:
      value = EShakaLogLevel.V1;
      break;
    case EShakaLogString.V2:
      value = EShakaLogLevel.V2;
      break;
    default:
      break;
  }

  return value;
}

declare global {
  interface Window {
    shaka: {
      log: {
        setLevel: (level: number) => void;
      };
    };
    performance: {
      memory: any | unknown;
    };
  }
}

export const shaka = {
  logs: {
    setLevel: (level: EShakaLogString) => {
      if (window?.shaka?.log?.setLevel && level) {
        const levelParsed = parseLogLevel(level);
        if (levelParsed !== undefined) {
          window.shaka.log.setLevel(levelParsed);
        }
      }
    },
    level: EShakaLogString,
  },
  stats: {
    on: () => {
      store().dispatch(Player.ActionCreators.activatePlayerStats(true));
    },
    off: () => {
      store().dispatch(Player.ActionCreators.activatePlayerStats(false));
    },
  },
};
